import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24f6b50a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rpp-ltl" }
const _hoisted_2 = {
  key: 0,
  class: "w-full flex items-center justify-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-sm" }, "Загрузка данных...", -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold mr-2" }, "Норма тг/кг:", -1))
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold mr-2" }, "Факт тг/кг:", -1))
const _hoisted_10 = { class: "mb-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold mr-2" }, "Норма тг/м3:", -1))
const _hoisted_12 = { class: "mb-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold mr-2" }, "Факт тг/м3:", -1))
const _hoisted_14 = { class: "mb-2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold mr-2" }, "Изменение стоимости:", -1))
const _hoisted_16 = { class: "bg-white py-4 px-6" }
const _hoisted_17 = { class: "flex items-center justify-end gap-4" }
const _hoisted_18 = { class: "relative" }
const _hoisted_19 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_20 = {
  key: 0,
  class: "flex flex-col items-center justify-center"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-sm" }, "Загрузка данных...", -1))
const _hoisted_22 = {
  key: 1,
  class: "flex flex-col items-center justify-center text-red-500"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "При получении данных произошла ошибка", -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "PaginationHolder" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))
const _hoisted_29 = {
  key: 7,
  class: "whitespace-nowrap"
}
const _hoisted_30 = { class: "PaginationHolder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_the_textarea = _resolveComponent("the-textarea")!
  const _component_new_modal = _resolveComponent("new-modal")!
  const _component_export_ltl_excel_modal = _resolveComponent("export-ltl-excel-modal")!
  const _component_rpp_update_modal = _resolveComponent("rpp-update-modal")!
  const _component_rpp_mass_change_status = _resolveComponent("rpp-mass-change-status")!
  const _component_rpp_general_tabs = _resolveComponent("rpp-general-tabs")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_rpp_ltl_filters = _resolveComponent("rpp-ltl-filters")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_columns_icon = _resolveComponent("columns-icon")!
  const _component_new_columns_controller = _resolveComponent("new-columns-controller")!
  const _component_new_limit = _resolveComponent("new-limit")!
  const _component_new_pagination = _resolveComponent("new-pagination")!
  const _component_new_checkbox = _resolveComponent("new-checkbox")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_new_table = _resolveComponent("new-table")!
  const _component_rpp_ltl_list_item = _resolveComponent("rpp-ltl-list-item")!
  const _component_list = _resolveComponent("list")!
  const _component_new_view_manager = _resolveComponent("new-view-manager")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_submit)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 0,
          title: "Подтверждение РПП",
          loading: _ctx.state.is_submit_loading,
          onCancel: _ctx.toggleSubmit,
          onSubmit: _ctx.submit
        }, {
          default: _withCtx(() => [
            (_ctx.state.is_submit_loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_loader),
                  _hoisted_3
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _hoisted_7,
                      _createTextVNode(_toDisplayString(_ctx.state.cost_comparison.costPerWeightStandard || '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createTextVNode(_toDisplayString(_ctx.state.cost_comparison.costPerWeightActual || '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createTextVNode(_toDisplayString(_ctx.state.cost_comparison.costPerCubatureStandard || '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createTextVNode(_toDisplayString(_ctx.state.cost_comparison.costPerCubatureActual || '-'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createTextVNode(_toDisplayString(_ctx.state.cost_comparison.costDifference || '-'), 1)
                  ]),
                  _createVNode(_component_the_textarea, {
                    disabled: _ctx.state.is_submit_loading,
                    autoheight: "",
                    rows: 4,
                    placeholder: "Комментарий",
                    value: _ctx.state.comment,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.comment) = $event))
                  }, null, 8, ["disabled", "value"])
                ]))
          ]),
          _: 1
        }, 8, ["loading", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_export)
      ? (_openBlock(), _createBlock(_component_export_ltl_excel_modal, {
          key: 1,
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.is_export = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.update_state.is_opened)
      ? (_openBlock(), _createBlock(_component_rpp_update_modal, {
          key: 2,
          "rpp-id": _ctx.update_state.rpp_id,
          onCancel: _ctx.onStopUpdateRpp
        }, null, 8, ["rpp-id", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.mass_confirm_state.is_opened)
      ? (_openBlock(), _createBlock(_component_rpp_mass_change_status, {
          key: 3,
          title: "Массовое подтверждение",
          "payment-by-supplier-ids": _ctx.state.paymentBySupplierIds,
          onCancel: _ctx.onMassConfirmClose,
          onSuccess: _ctx.onMassConfirmSuccess
        }, null, 8, ["payment-by-supplier-ids", "onCancel", "onSuccess"]))
      : _createCommentVNode("", true),
    _createVNode(_component_rpp_general_tabs, {
      value: "ltl",
      onExportLtlData: _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.is_export = true))
    }),
    _createVNode(_component_page_title, {
      title: "Список РПП LTL",
      class: "mt-6"
    }),
    _createVNode(_component_rpp_ltl_filters, {
      class: "mt-3",
      loading: _ctx.state.is_loading,
      onSubmit: _ctx.onFiltersSubmit,
      onReset: _ctx.onFiltersReset
    }, null, 8, ["loading", "onSubmit", "onReset"]),
    _createVNode(_component_new_view_manager, {
      value: _ctx.state.view,
      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.view) = $event)),
      class: "mt-3"
    }, {
      table: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_new_button, {
              class: "NewButton--30",
              disabled: _ctx.state.paymentBySupplierIds.length < 1,
              onClick: _ctx.onMassConfirm
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Массовое подтверждение ")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_new_button, {
                class: "NewButton--outline NewButton--30",
                onClick: _ctx.openColumnsController
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_columns_icon, { class: "CmsInvoicesContainer__icon mr-2" }),
                  _createTextVNode(" Колонки ")
                ]),
                _: 1
              }, 8, ["onClick"]),
              (_ctx.state.is_columns_controller_opened)
                ? (_openBlock(), _createBlock(_component_new_columns_controller, {
                    key: 0,
                    "columns-parent": _ctx.TABLE_COLUMNS,
                    value: _ctx.state.columns,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.columns) = $event)),
                    onOutsideClick: _ctx.closeColumnsController
                  }, null, 8, ["columns-parent", "value", "onOutsideClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.state.is_loading || _ctx.state.is_failed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                (_ctx.state.is_loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createVNode(_component_loader, { class: "primary" }),
                      _hoisted_21
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.is_failed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_new_limit, {
                    disabled: _ctx.state.is_loading,
                    "total-items": _ctx.state.pagination.total_items,
                    value: _ctx.state.filters.limit,
                    onChange: _ctx.onLimitChange
                  }, null, 8, ["disabled", "total-items", "value", "onChange"]),
                  _createVNode(_component_new_pagination, {
                    class: "ml-6",
                    disabled: _ctx.state.is_loading,
                    "current-page": _ctx.state.filters.page,
                    "total-pages": _ctx.state.pagination.total_pages,
                    onChangePage: _ctx.onChangePage
                  }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
                ]),
                _createVNode(_component_new_table, {
                  class: "mt-3",
                  columns: _ctx.state.columns,
                  rows: _ctx.state.list,
                  "has-checkbox-column": "",
                  nowrap: "",
                  "selected-rows": _ctx.state.paymentBySupplierIds,
                  onRowClick: _ctx.onRowClicked,
                  onSelectAll: _ctx.selectAllPaymentBySupplierIds
                }, {
                  checkbox: _withCtx(({ row, disabled, checked }) => [
                    (row.statusId === 11)
                      ? (_openBlock(), _createBlock(_component_new_checkbox, {
                          key: 0,
                          class: "checkbox--blue",
                          value: checked,
                          disabled: disabled,
                          onChange: ($event: any) => (_ctx.selectPaymentBySupplierId(row))
                        }, null, 8, ["value", "disabled", "onChange"]))
                      : _createCommentVNode("", true)
                  ]),
                  td: _withCtx(({ row, column }) => [
                    (column.key === 'type_of_transportation')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" LTL ")
                        ], 64))
                      : (column.key === 'pbsDate')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.formatDate(row.pbsDate)), 1)
                          ], 64))
                        : (column.key === 'statusName')
                          ? (_openBlock(), _createBlock(_component_cheap, {
                              key: 2,
                              class: _normalizeClass(["small whitespace-nowrap", {
                                            green: row.statusId === 15,
                                            yellow: row.statusId === 13,
                                            red: row.statusId === 11,
                                        }])
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(row[column.key]), 1)
                              ]),
                              _: 2
                            }, 1032, ["class"]))
                          : (column.key === 'pbsNumber')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                (row.id)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      class: "text-blue-500",
                                      to: `/rpp/ltl/${row.id}`,
                                      target: "_blank"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(row.pbsNumber), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : (column.key === 'tripNumber')
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 4,
                                  class: "text-blue-500",
                                  to: `/tms/trips/${row.tripId}`,
                                  target: "_blank"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(row.tripNumber), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              : (column.key === 'ttns')
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 5 }, _renderList(row.ttns, (ttn, i) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: `ttn-${ttn.id}`
                                    }, [
                                      _createVNode(_component_router_link, {
                                        class: "text-blue-500",
                                        to: `/tms/ttns/${ttn.id}`,
                                        target: "_blank"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(ttn.number), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"]),
                                      (i + 1 < row.ttns.length)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, ", "))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                : (column.key === 'actions')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                      (row.statusId === 13 || row.statusId === 15)
                                        ? (_openBlock(), _createBlock(_component_new_button, {
                                            key: 0,
                                            class: "mr-2",
                                            onClick: ($event: any) => (_ctx.onStartUpdateRpp(row.id))
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_28
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : _createCommentVNode("", true),
                                      (row.statusId === 11)
                                        ? (_openBlock(), _createBlock(_component_new_button, {
                                            key: 1,
                                            class: "mr-2",
                                            onClick: ($event: any) => (_ctx.toggleSubmit(row.id, row.tripId))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Подтвердить ")
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : _createCommentVNode("", true),
                                      (row.statusId === 15)
                                        ? (_openBlock(), _createBlock(_component_new_button, {
                                            key: 2,
                                            onClick: ($event: any) => (_ctx.printRpp(row.id))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Распечатка ")
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(row[column.key] || '-'), 1))
                  ]),
                  _: 1
                }, 8, ["columns", "rows", "selected-rows", "onRowClick", "onSelectAll"]),
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_new_limit, {
                    disabled: _ctx.state.is_loading,
                    "total-items": _ctx.state.pagination.total_items,
                    value: _ctx.state.filters.limit,
                    onChange: _ctx.onLimitChange
                  }, null, 8, ["disabled", "total-items", "value", "onChange"]),
                  _createVNode(_component_new_pagination, {
                    class: "ml-6",
                    disabled: _ctx.state.is_loading,
                    "current-page": _ctx.state.filters.page,
                    "total-pages": _ctx.state.pagination.total_pages,
                    onChangePage: _ctx.onChangePage
                  }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
                ])
              ]))
        ])
      ]),
      list: _withCtx(() => [
        _createVNode(_component_list, {
          loading: _ctx.state.is_loading,
          items: _ctx.state.list,
          pagination: "",
          "pagination-current-page": _ctx.state.filters.page,
          "pagination-limit": _ctx.state.filters.limit,
          "pagination-total-items": _ctx.state.pagination.total_items,
          "pagination-total-pages": _ctx.state.pagination.total_pages
        }, {
          actions: _withCtx(() => [
            _createVNode(_component_new_button, {
              disabled: _ctx.state.paymentBySupplierIds.length < 1,
              onClick: _ctx.onMassConfirm
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Массовое подтверждение ")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]),
            _createVNode(_component_new_button, {
              disabled: _ctx.state.is_loading,
              onClick: _ctx.selectAllPaymentBySupplierIds
            }, {
              default: _withCtx(() => [
                _createTextVNode("Выбрать все")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ]),
          item: _withCtx(({ item }) => [
            _createVNode(_component_rpp_ltl_list_item, {
              item: item,
              "is-selected": _ctx.state.paymentBySupplierIds.includes(item.id),
              onUpdate: _ctx.onStartUpdateRpp,
              onSubmit: _ctx.toggleSubmit,
              onSelect: _ctx.selectPaymentBySupplierId,
              onUnselect: _ctx.unselectPaymentBySupplierId
            }, null, 8, ["item", "is-selected", "onUpdate", "onSubmit", "onSelect", "onUnselect"])
          ]),
          _: 1
        }, 8, ["loading", "items", "pagination-current-page", "pagination-limit", "pagination-total-items", "pagination-total-pages"])
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}